<template>
  <!-- Loading overlay durante tradução -->
  <TranslationOverlay :show="isTranslating" :locale="locale" />

  <!-- Conteúdo principal (escondido durante tradução) -->
  <div v-show="!isTranslating">
    <div v-if="showMenu" class="main-div">
      <Header />
      <div class="content-div">
        <router-view />
      </div>
      <Footer />
    </div>
    <div
      v-else
      class="d-flex align-items-center justify-content-center w-100 center"
    >
      <router-view />
    </div>
  </div>

  <!-- Componentes globais -->
  <ModalLoading />
  <ToastGlobal />

  <!-- Google Translate Widget (escondido mas funcional) -->
  <div id="google_translate_element" style="display: none"></div>
</template>

<script lang="ts">
  import Header from '@/components/Organisms/Header.vue'
  import Footer from '@/components/Organisms/Footer.vue'
  import ModalLoading from '@/components/templates/ModalLoading.vue'
  import ToastGlobal from './components/templates/ToastGlobal.vue'
  import TranslationOverlay from '@/components/TranslationOverlay.vue'
  import { defineComponent, computed, onMounted, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { Tooltip } from 'bootstrap'
  import { useEmbedConfig, useGoogleTranslate } from '@/composables'

  export default defineComponent({
    components: {
      Footer,
      ModalLoading,
      ToastGlobal,
      Header,
      TranslationOverlay,
    },
    setup() {
      const route = useRoute()

      const { isEmbedMode, locale, initFromQuery } = useEmbedConfig()
      const { isTranslating, initTranslation } = useGoogleTranslate()

      const processEmbedConfig = () => {
        // Lê query params e salva no sessionStorage
        initFromQuery(route)

        // Inicializa tradução se necessário
        if (locale.value && locale.value !== 'pt-BR' && locale.value !== 'pt') {
          initTranslation(locale.value)
        }
      }

      onMounted(() => {
        processEmbedConfig()

        setTimeout(() => {
          const tooltipTriggerList = document.querySelectorAll(
            '[data-bs-toggle="tooltip"]',
          )
          ;[...tooltipTriggerList].map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl),
          )
        }, 50)
      })

      watch(
        () => route.query,
        () => {
          processEmbedConfig()
        },
        { deep: true },
      )

      // Computed para mostrar menu (Header/Footer)
      // Esconde se for modo embed OU se for rota especial
      const showMenu = computed(() => {
        if (isEmbedMode.value) {
          return false
        }

        return (
          route.name !== 'WithoutRoute' &&
          route.name !== 'Error404' &&
          route.name !== 'BadSproLink'
        )
      })

      return {
        isEmbedMode,
        locale,
        isTranslating,
        showMenu,
      }
    },
  })
</script>

<style lang="stylus">
  *
    margin: 0
    padding: 0
    box-sizing: border-box

  .center
    height: 100vh

  body
    background-color: #FFFFFF // #FCFCFC
    overflow-y: auto !important
    height: 100%

  html
    height: 100%

  .main-div
    display: flex
    flex-direction: column
    justify-content: space-between;
    height: 100%

  .content-div
    height: 100%
    height: max-content
    flex-grow: 1

    router-view
      flex-grow: 1
      align-self: start
      height: 100%
      height: max-content

  .modal-dialog {
    z-index: 999999;
  }

  #app
    font-family 'Poppins', Helvetica, Arial, sans-serif
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    text-align center
    height: 100%
    overflow-y: auto !important

  .vs__dropdown-toggle
    border: none !important
    padding: 0 !important;

  .vs__actions
    display: none !important
    color: #212529 !important
    padding: 0 !important

  .vs__search
    margin: 0 !important

  .vs__selected
    margin: 0 !important

  .no-options
    display: none

    :root {
      --tooltip-font-size: 1rem;
    }

  .offcanvas
    z-index: 1051

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  input:-internal-autofill-selected
    background-color: #FFF !important;

  @media screen and (min-width: 1170px) {
    .container {
      max-width: 1170px !important
    }
  }

  // Override Ilios primary color
  .color--primary
    color: #19665B !important
</style>
